export const state = () => ({
  productMasterList: [],
  createProductMasterSuccess: null,
  deleteProductMasterSuccess: null,
  updateProductMasterSuccess: null,
  propagateProductMasterSuccess: null,
  productSearchListSuccess: null,
  productSearchList: [],
  productSearchProgress: 0.0,
  productSearchListCancelToken: null
});
